import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    invoice: '{0} invoice',
    invoices: '{0} invoices',
    noDocumentsYet: 'No documents yet',
    overdueInvoice: '{0} overdue invoice',
    overdueInvoices: '{0} overdue invoices',
    quote: '{0} quote',
    quotes: '{0} quotes',
  },
  fr: {
    invoice: '{0} facture',
    invoices: '{0} factures',
    noDocumentsYet: 'Pas encore de documents',
    overdueInvoice: '{0} facture en retard',
    overdueInvoices: '{0} factures en retard',
    quote: '{0} devis',
    quotes: '{0} devis',
  },
});

export default locales;
